import { api } from "./api_client";
import axios from "axios";
import { Airport } from "../models/airport";
import { transformAirport } from "../utils/game_transforms";

export default async function fetchAirports(
  difficulty: "easy" | "medium" | "hard",
  region: string,
  signal?: AbortSignal
): Promise<Airport[]> {
  try {
    const response = await api.get(
      `/airports?difficulty=${difficulty}&region=${region}`,
      {
        signal,
      }
    );
    return response.data.map(transformAirport);
  } catch (error) {
    if (axios.isCancel(error)) {
      console.log("Request aborted");
    } else {
      console.error("Error fetching data:", error);
    }

    throw error;
  }
}
